<template>
  <div class="menu-container">
    <el-scrollbar style="flex: 1">
      <div class="h-100">
        <el-menu class="el-menu-vertical-demo" default-active="1" unique-opened>
          <template v-for="(item, index) in menuList">
            <el-submenu class="menuLocation" :key="index" :index="(index + 1) + ''"
              v-if="item.child && item.child.length && (!item.permission || permissionIn(item.permission))">
              <div slot="title" class="no-child">
                <img :src="'/static/images/' + item.img + '.png'" class="default-menu-img menu-img" alt="">
                <img :src="'/static/images/' + item.img + '.png'" class="active-menu-img menu-img" alt="">
                <span slot="title">{{item.name}}</span>
              </div>
              <el-menu-item class="menuLocationChild" v-for="(child, idx) in item.child" :key="idx"
                :index="(index + 1) + '-' + (idx+1)" v-if="!child.permission || permissionIn(child.permission)"
                @click="toPage(child)">
                <span slot="title">{{child.name}}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :key="index" class="no-child myMenu" :index="(index + 1) + ''"
              v-else-if="!item.permission || permissionIn(item.permission)" @click="toPage(item)">
              <img :src="'/static/images/' + item.img + '.png'" class="default-menu-img menu-img" alt="">
              <img :src="'/static/images/' + item.img + 'xz.png'" class="active-menu-img menu-img" alt="">
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  components: {},
  data () {
    return {
      menu: this.$store.state.menu || '',
      menu_: [],
      isCollapse: false,
      menuList: [
        {
          img: 'shouye',
          path: '/welcome/index',
          name: '首页',
          isShow: false
        },
        // {
        //   img: 'shouye',
        //   name: '示范页',
        //   child: [{
        //     name: '示范页1',
        //     path: '/welcome2/index'
        //   }, {
        //     name: '示范页2',
        //     path: '/welcome2/index01'
        //   }, {
        //     name: '报表',
        //     path: '/report/demo'
        //   }]
        // },
        {
          img: 'kehuguanli',
          name: '客户管理',
          permission: 'customerManage',
          isShow: false,
          child: [{
            name: '装修客户',
            path: 'flag',
            isShow: false
          }, {
            name: '飞单客户',
            path: '/customer/flyOrder',
            permission: 'flyOrder',
            isShow: false
          }, {
            name: '全部客户',
            path: '/customer/all',
            permission: 'all',
            isShow: false
          }]
        },
        {
          img: 'caiwuguanli',
          name: '财务管理',
          permission: 'financeManage',
          isShow: false,
          child: [
            {
              name: '待记账工程款',
              path: '/financeManage/recordedProjectFund',
              permission: 'recordedProjectFund',
              isShow: false
            },
            {
              name: '在建工程明细',
              path: '/financeManage/projectDetailedAccount',
              permission: 'projectDetailedAccount',
              isShow: false
            },
            {
              name: '付材料采购款',
              path: '/financeManage/purchaseMaterialPayment',
              permission: 'purchaseMaterialPayment',
              isShow: false
            },
            {
              name: '出纳流水账',
              path: '/financeManage/cashierFlowAccount',
              permission: 'cashierFlowAccount',
              isShow: false
            }
          ]
        },
        {
          img: 'xingzhengguanli',
          name: '行政管理',
          permission: 'administrativeManagement',
          isShow: false,
          child: [{
            name: '公司人员定义',
            path: '/administrative/employeeDefine',
            permission: 'employeeDefine',
            isShow: false
          }, {
            name: '公司公告发布',
            path: '/administrative/announcement',
            permission: 'announcement',
            isShow: false
          }]
        },
        {
          img: 'dingdanguanli',
          name: '订单管理',
          permission: 'orderManage',
          isShow: false,
          child: []
          // child: [{
          //   name: '材料入库单',
          //   path: '/order/materialIn',
          //   permission: 'materialInputOrder',
          //   isShow: false
          // }, {
          //   name: '材料入库退单',
          //   path: '/order/materialInReturned',
          //   permission: 'materialInputReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '材料出库单',
          //   path: '/order/materialOut',
          //   permission: 'materialOutputOrder',
          //   isShow: false
          // }, {
          //   name: '材料出库退料单',
          //   path: '/order/materialOutReturned',
          //   permission: 'materialOutputReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '库存报损单',
          //   path: '/order/reportLoss',
          //   permission: 'reportLossOrder',
          //   isShow: false
          // }, {
          //   name: '库存报溢单',
          //   path: '/order/reportOverflow',
          //   permission: 'reportOverflowOrder',
          //   isShow: false
          // }, {
          //   name: '辅材调拨单',
          //   path: '/order/auxiliaryMaterials',
          //   permission: 'auxiliaryMaterialsOrder',
          //   isShow: false
          // }, {
          //   name: '辅材调拨退料单',
          //   path: '/order/auxiliaryMaterialsReturned',
          //   permission: 'auxiliaryMaterialsReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '主材调拨单',
          //   path: '/order/mainMaterials',
          //   permission: 'mainMaterialsOrder',
          //   isShow: false
          // }, {
          //   name: '主材调拨退料单',
          //   path: '/order/mainMaterialsReturned',
          //   permission: 'mainMaterialsReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '软装调拨单',
          //   path: '/order/softMaterials',
          //   permission: 'softMaterialsOrder',
          //   isShow: false
          // }, {
          //   name: '软装调拨退料单',
          //   path: '/order/softMaterialsReturned',
          //   permission: 'softMaterialsReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '主材补货单',
          //   path: '/order/mainMaterialsReplenishment',
          //   permission: 'mainMaterialsReplenishmentOrder',
          //   isShow: false
          // }, {
          //   name: '库存台账',
          //   path: '/order/inventoryStock',
          //   permission: 'stock',
          //   isShow: false
          // }, {
          //   name: '电器调拨单',
          //   path: '/order/electricAppliance',
          //   permission: 'electricalEquipmentOrder',
          //   isShow: false
          // }, {
          //   name: '电器调拨退单',
          //   path: '/order/electricApplianceReturned',
          //   permission: 'electricalEquipmentReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '合同外材料调拨单',
          //   path: '/order/contractMaterials',
          //   permission: 'outContractOrder',
          //   isShow: false
          // }, {
          //   name: '合同外材料调拨退单',
          //   path: '/order/contractMaterialsReturned',
          //   permission: 'outContractReturnedOrder',
          //   isShow: false
          // }, {
          //   name: '主材调拨单(自由单)',
          //   path: '/order/mainMaterialsFree',
          //   permission: 'freeOrder',
          //   isShow: false
          // }, {
          //   name: '主材调拨退料单(自由单)',
          //   path: '/order/mainMaterialsReturnedFree',
          //   permission: 'freeReturnedOrder',
          //   isShow: false
          // }]
        },
        {
          img: 'dingechaxun',
          path: '/quotaSearch/index',
          name: '定额查询',
          permission: 'quotaSearch'
        },
        {
          img: 'cailiaochaxun',
          path: '/materialSearch/index',
          name: '材料查询',
          permission: 'materialSearch'
        },
        {
          img: 'chenggonganli',
          path: '/successfulCases/index',
          name: '成功案例',
          permission: 'successfulCases'
        },
        {
          img: 'xitongdingyi',
          name: '系统定义',
          permission: 'systemDefine',
          isShow: false,
          child: [{
            name: '基础信息定义',
            path: '/systemDefine/basicDefine',
            permission: 'basicDefine',
            isShow: false
          }, {
            name: '工程进度计划定义',
            path: '/systemDefine/projectProgressDefine',
            permission: 'projectProgressDefine',
            isShow: false
          }, {
            name: '供应商定义',
            path: '/systemDefine/businessDefine',
            permission: 'businessDefine',
            isShow: false
          }, {
            name: '材料及价格定义',
            path: '/systemDefine/materialDefine',
            permission: 'materialDefine',
            isShow: false
          }, {
            name: '房间包含定义',
            path: '/systemDefine/roomBagDefine',
            permission: 'budgetPackageDefine',
            isShow: false
          }, {
            name: '报价模板定义',
            path: '/systemDefine/quotationTemplateDefine',
            permission: 'budgetTemplateDefine',
            isShow: false
          }, {
            name: '部门指派定义',
            path: '/systemDefine/departmentAssignDefine',
            permission: 'departmentAssignDefine',
            isShow: false
          }, {
            name: '工程定额定义',
            path: '/systemDefine/quotaDefine',
            permission: 'projectQuotaDefine',
            isShow: false
          }, {
            name: '单据定义',
            path: '/systemDefine/materialOrderDefine',
            permission: 'materialOrderDefine',
            isShow: false
          }, {
            name: '客户界面定义',
            path: '/systemDefine/customerViewDefine',
            permission: 'customerViewDefine',
            isShow: false
          }, {
            name: '流程提交必填项定义',
            path: '/systemDefine/ProgressSubmitMustDefine',
            permission: 'progressSubmitMustDefine',
            isShow: false
          }, {
            name: '岗位权限定义',
            path: '/systemDefine/stationDefine',
            permission: 'stationDefine',
            isShow: false
          }, {
            name: '收款通知单定义',
            path: '/systemDefine/receivablesDefine',
            permission: 'receivablesDefine',
            isShow: false
          }, {
            name: '付款通知单定义',
            path: '/systemDefine/paymentDefine',
            permission: 'paymentDefine',
            isShow: false
          }, {
            name: '项目提成定义',
            path: '/systemDefine/percentageDefine',
            permission: 'percentageDefine',
            isShow: false
          }, {
            name: '仓库定义',
            path: '/systemDefine/warehouseDefine',
            permission: 'warehouseDefine',
            isShow: false
          }, {
            name: '库存过账期间定义',
            path: '/systemDefine/inventoryPeriodrDefine',
            permission: 'inventoryPeriodrDefine',
            isShow: false
          }, {
            name: '期初库存台账',
            path: '/systemDefine/startInventoryDefine',
            permission: 'startInventoryDefine',
            isShow: false
          }, {
            name: '银行账户定义',
            path: '/systemDefine/bankAccountDefine',
            permission: 'bankAccountDefine',
            isShow: false
          }, {
            name: '公司定义',
            path: '/systemDefine/companyDefine',
            permission: 'companyDefine',
            isShow: false
          }, {
            name: '报表定义',
            path: '/systemDefine/reportDefine',
            permission: 'reportDefine',
            isShow: false
          }]
        },
        {
          img: 'juecezhongxin',
          path: '/decisionCenter/index',
          name: '决策中心',
          permission: 'decisionCenter'
        }
      ]
    }
  },
  created () {
  },
  activated () {
  },
  mounted () {
    this.getMenuList()
    // if (!this.menu) {
    this.axios.post(`${this.$store.state.API_URL_9010}/permission/menuStr`).then(res => {
      this.menu = res.data.data
      this.menu_ = res.data.data.split(',')
      this.$store.dispatch('setMenu', res.data.data)
    })
    // }
  },
  methods: {
    getMenuList () {
      this.axios.post('orderDefine/list', { companyId: this.$store.state.companyId, usePermission: 1 }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          let arr = []
          for (let m = 0; m < list.length; m++) {
            let obj = {
              name: list[m].name,
              type: list[m].type,
              id: list[m].id,
              path: '/order/mainMaterials',
              permission: list[m].permission,
              isShow: false
            }
            arr.push(obj)
          }
          arr.push(
            {
              name: '库存台账',
              path: '/order/inventoryStock',
              permission: 'stock',
              isShow: false
            }
          )
          for (let i = 0; i < this.menuList.length; i++) {
            if (this.menuList[i].name === '订单管理') {
              this.menuList[i].child = arr
            }
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    toPage: function (e) {
      let path = e.path
      let type = e.type
      let id = e.id
      if (path === 'flag') {
        let list = [
          {
            name: '储备客户',
            path: '/customer/reserveCustomer',
            permission: 'reserveCustomer',
            isShow: false
          }, {
            name: '咨询客户',
            path: '/customer/doorCustomer',
            permission: 'doorCustomer',
            isShow: false
          }, {
            name: '订金客户',
            path: '/customer/intentionCustomer',
            permission: 'intention',
            isShow: false
          }, {
            name: '概算合同',
            path: '/customer/budgetContract',
            permission: 'budgetContract',
            isShow: false
          }, {
            name: '设计合同',
            path: '/customer/designContractCustomer',
            permission: 'designContract',
            isShow: false
          }, {
            name: '预算审核',
            path: '/customer/budgetExamine',
            permission: 'budgetExamine',
            isShow: false
          }, {
            name: '施工合同',
            path: '/customer/constructionContract',
            permission: 'constructionContract',
            isShow: false
          }, {
            name: '施工客户',
            path: '/customer/projectManager',
            permission: 'projectManager',
            isShow: false
          }, {
            name: '售后服务',
            path: '/customer/afterSales',
            permission: 'afterSales',
            isShow: false
          }
        ]
        for (let i = 0; i < list.length; i++) {
          if (this.menu.indexOf(list[i].permission) > -1) {
            path = list[i]
            this.toPage(path)
            return
          }
        }
      } else {
        if (type) {
          if (this.$route.fullPath !== path) {
            this.$router.replace({ path: path, query: { type: type, id: id } })
          }
        } else {
          if (this.$route.fullPath !== path) {
            this.$router.replace(path)
          }
        }
      }
    },
    collapseMenu: function () {
      this.isCollapse = !this.isCollapse
    },
    permissionIn: function (permission) {
      return this.menu_.indexOf(permission) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  background-color: #292D36;
  color: #e2e2e2;
}

.el-menu-vertical-demo {
  height: 100%;
  border-right: none;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
}

.menu-container {
  height: 100%;
  background-color: #292D36;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  z-index: 9;
  display: flex;
  // flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.el-menu-item:focus,
.el-menu-item:hover {
  // background-color: transparent;
  background-color: #303642;
  cursor: pointer;
  color: #87A5BA;
}

.no-child {
  text-align: left;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #303642;
  color: #87A5BA;
  font-size: 15px;
  margin-top: 10px;

  .active-menu-img {
    display: none;
  }

  &.is-active {
    background-color: #303642;
    color: #46B8B0;

    .active-menu-img {
      display: block;
    }

    .default-menu-img {
      display: none;
    }
  }

  span {
    line-height: 28px;
  }

  .menu-img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
}

.myMenu {
  &.is-active::before {
    content: '';
    position: absolute;
    right: 0;
    top: 10%;
    width: 4px;
    height: 80%;
    background-color: #46B8B0;
  }
}

.collapse-container {
  height: 44px;
  background: #BAB5B1;
  padding: 12px;
  display: flex;
  text-align: left;
  cursor: pointer;
}

.user-info {
  height: 51px;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px dashed #e2e2e2;
  background: #46b8b0;
}

.logo-img {
  width: 126px;
  height: 24px;
}

.menu-container /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue